import axios, { type AxiosError } from 'axios';

export const isOfErrorType = <T>(error: unknown, status: number): error is AxiosError<T> =>
    axios.isAxiosError(error) && error?.response?.status === status;

const noop = () => {
    /* empty */
};
export function debouncePromise<Args extends unknown[], R>(
    fn: (...args: Args) => R,
    wait: number,
    abortValue?: unknown
) {
    let cancel = noop;
    let lastCallAt: number;

    const wrapFunc = (...args: Args): Promise<Awaited<R>> => {
        cancel();

        const currentTime = new Date().getTime();
        const isCold = !lastCallAt || currentTime - lastCallAt > wait;
        lastCallAt = currentTime;

        if (isCold) {
            return Promise.resolve(fn(...args));
        }

        return new Promise<Awaited<R>>((resolve, reject) => {
            const timer = setTimeout(() => {
                resolve(fn(...args) as Awaited<R>);
            }, wait);

            cancel = () => {
                clearTimeout(timer);
                if (abortValue !== undefined) {
                    reject(abortValue);
                }
            };
        });
    };

    return wrapFunc;
}
